const NON_ASCII_RE = /[\u0080-\uffff]/;
const CJK_RE = /[\u3400-\u9fff]/g;
const CP1252_SUSPICIOUS_RE = /[\u00c0-\u00ff\u0152\u0153\u0160\u0161\u0178\u017d\u017e\u0192\u02c6\u02dc\u2013-\u203a]/g;
const CP1252_BYTE_MAP = {
  0x20ac: 0x80,
  0x201a: 0x82,
  0x0192: 0x83,
  0x201e: 0x84,
  0x2026: 0x85,
  0x2020: 0x86,
  0x2021: 0x87,
  0x02c6: 0x88,
  0x2030: 0x89,
  0x0160: 0x8a,
  0x2039: 0x8b,
  0x0152: 0x8c,
  0x017d: 0x8e,
  0x2018: 0x91,
  0x2019: 0x92,
  0x201c: 0x93,
  0x201d: 0x94,
  0x2022: 0x95,
  0x2013: 0x96,
  0x2014: 0x97,
  0x02dc: 0x98,
  0x2122: 0x99,
  0x0161: 0x9a,
  0x203a: 0x9b,
  0x0153: 0x9c,
  0x017e: 0x9e,
  0x0178: 0x9f
};

function toCp1252Bytes(value) {
  const bytes = [];
  for (const char of Array.from(value)) {
    const code = char.charCodeAt(0);
    if (code <= 0xff) {
      bytes.push(code);
      continue;
    }
    if (Object.prototype.hasOwnProperty.call(CP1252_BYTE_MAP, code)) {
      bytes.push(CP1252_BYTE_MAP[code]);
      continue;
    }
    return null;
  }
  return Uint8Array.from(bytes);
}

function decodeUtf8(bytes) {
  if (!bytes) {
    return null;
  }
  if (typeof TextDecoder !== "undefined") {
    try {
      return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
    } catch (e) {
      // Fall back to percent-decoding below.
    }
  }
  try {
    const encoded = Array.from(bytes, (byte) => `%${byte.toString(16).padStart(2, "0")}`).join("");
    return decodeURIComponent(encoded);
  } catch (e) {
    return null;
  }
}

function countMatches(value, regex) {
  const matches = value.match(regex);
  return matches ? matches.length : 0;
}

function scoreString(value) {
  return countMatches(value, CJK_RE) * 4 - countMatches(value, CP1252_SUSPICIOUS_RE) * 2;
}

function tryDecode(value) {
  const decoded = decodeUtf8(toCp1252Bytes(value));
  return decoded || value;
}

export function decodeMojibakeString(value) {
  if (typeof value !== "string" || value.length === 0 || !NON_ASCII_RE.test(value)) {
    return value;
  }
  let current = value;
  for (let i = 0; i < 2; i += 1) {
    const decoded = tryDecode(current);
    if (!decoded || decoded === current) {
      break;
    }
    if (scoreString(decoded) <= scoreString(current)) {
      break;
    }
    current = decoded;
  }
  return current;
}

export function decodeMojibakeDeep(value, seen = new WeakMap()) {
  if (typeof value === "string") {
    return decodeMojibakeString(value);
  }
  if (!value || typeof value !== "object") {
    return value;
  }
  if (seen.has(value)) {
    return seen.get(value);
  }
  if (Array.isArray(value)) {
    const repaired = [];
    seen.set(value, repaired);
    value.forEach((item) => {
      repaired.push(decodeMojibakeDeep(item, seen));
    });
    return repaired;
  }
  const repaired = {};
  seen.set(value, repaired);
  Object.keys(value).forEach((key) => {
    repaired[key] = decodeMojibakeDeep(value[key], seen);
  });
  return repaired;
}
